"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7816],{

/***/ 3633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SectionContact; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2175);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4853);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7258);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7239);
/* harmony import */ var _utils_const__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3026);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}











function SectionContact(param2) {
    var _color = param2.color, color = _color === void 0 ? "black" : _color, email1 = param2.email, emailParticipants = param2.emailParticipants, location = param2.location, phone1 = param2.phone, srcMap = param2.srcMap, hotel = param2.hotel;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(""), capKey = ref[0], setCapKey = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), isCapValid = ref1[0], setIsCapValid = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_9__/* .postCapthca */ .ay)({
            response: capKey
        }).then(function(res) {
            res.data.success == true ? setIsCapValid(true) : setIsCapValid(false);
        });
    }, [
        capKey
    ]);
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useFormik */ .TA)({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            message: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_7__/* .object */ .Ry({
            name: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().max(20).required(locale == "id" ? "Harus diisi" : "Required"),
            email: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().email(locale == "id" ? "Email tidak valid" : "Please enter a valid email").required(locale == "id" ? "Harus diisi" : "Required"),
            phone: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().matches(_utils_const__WEBPACK_IMPORTED_MODULE_10__/* .phoneRegExp */ .Oj, locale == "id" ? "Nomor telepon tidak valid" : "Phone must be a valid phone number").required(locale == "id" ? "Harus diisi" : "Required"),
            message: yup__WEBPACK_IMPORTED_MODULE_7__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required")
        }),
        onSubmit: function(param, param1) {
            var name = param.name, email = param.email, message = param.message, phone = param.phone, setSubmitting = param1.setSubmitting, setStatus = param1.setStatus;
        }
    });
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
            var _values, email, name, message, phone;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx1.next = 2;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 2:
                        if (isCapValid) {
                            _ctx1.next = 4;
                            break;
                        }
                        return _ctx1.abrupt("return");
                    case 4:
                        formik.setSubmitting(true);
                        _values = formik.values, email = _values.email, name = _values.name, message = _values.message, phone = _values.phone;
                        _ctx1.next = 8;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_9__/* .postMessages */ .lB)({
                            name: name,
                            email: email,
                            phone: phone,
                            message: message,
                            hotel: hotel
                        }).then(function() {
                            var _ref1 = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(res1) {
                                return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
                                    while(1)switch(_ctx2.prev = _ctx2.next){
                                        case 0:
                                            if (!(res1.status == 200)) {
                                                _ctx2.next = 3;
                                                break;
                                            }
                                            _ctx2.next = 3;
                                            return (0,_utils_api__WEBPACK_IMPORTED_MODULE_9__/* .postSendMail */ .ZC)({
                                                mailkey: "halo",
                                                emails: email,
                                                subject: "Your Contact Request",
                                                title: "Your Contact Request",
                                                hotel: hotel !== null && hotel !== void 0 ? hotel : "Home",
                                                name: name,
                                                body: "Just to let you know \u2014 we've received your Contact Request, and it is now being processed.",
                                                type: "Contact Us"
                                            }).then(function() {
                                                var _ref = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res2) {
                                                    return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                if (!(res2.status == 200)) {
                                                                    _ctx.next = 3;
                                                                    break;
                                                                }
                                                                _ctx.next = 3;
                                                                return (0,_utils_api__WEBPACK_IMPORTED_MODULE_9__/* .postSendMail */ .ZC)({
                                                                    mailkey: "halo",
                                                                    emails: emailParticipants,
                                                                    subject: "A Contact Request from Hotel Website",
                                                                    title: "A Contact Request from Hotel Website",
                                                                    hotel: hotel !== null && hotel !== void 0 ? hotel : "Parador",
                                                                    name: "Admins",
                                                                    body: '<div>\n                  <h3>\n                  A Message from Customer!\n                  </h3>\n                  <table class="detail-table">\n                    <tr>\n                      <td>Hotel</td>\n                      <td> : </td>\n                      <td>'.concat(hotel !== null && hotel !== void 0 ? hotel : "Parador", "</td>\n                    </tr>\n                    <tr>\n                      <td>Name</td>\n                      <td> : </td>\n                      <td>").concat(name, "</td>\n                    </tr>\n                    <tr>\n                      <td>Email</td>\n                      <td> : </td>\n                      <td>").concat(email, "</td>\n                    </tr>\n                    <tr>\n                      <td>Phone</td>\n                      <td> : </td>\n                      <td>").concat(phone, "</td>\n                    </tr>\n                    <tr>\n                      <td>Message</td>\n                      <td> : </td>\n                      <td>").concat(message, "</td>\n                    </tr>\n                  </table>\n                </div>"),
                                                                    type: "Contact Us"
                                                                }).then(function(res) {
                                                                    res.status == 200 && formik.setStatus("success");
                                                                });
                                                            case 3:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                }));
                                                return function(res2) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }());
                                        case 3:
                                        case "end":
                                            return _ctx2.stop();
                                    }
                                }, _callee2);
                            }));
                            return function(res1) {
                                return _ref1.apply(this, arguments);
                            };
                        }());
                    case 8:
                        formik.setSubmitting(false);
                    case 9:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return _handleClick.apply(this, arguments);
    }
    var _NEXT_PUBLIC_CAPTCHA_SITE_KEY;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Section__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        bg: "white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
            flexDir: "column",
            gap: 16,
            children: [
                srcMap && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                        src: srcMap,
                        width: "100%",
                        style: {
                            height: "70vh"
                        },
                        allowFullScreen: true,
                        loading: "lazy",
                        referrerPolicy: "no-referrer-when-downgrade"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                            mb: 12,
                            as: "h1",
                            fontWeight: 400,
                            letterSpacing: "wider",
                            color: color,
                            children: locale == "id" ? "KONTAK KAMI" : "CONTACT US"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                            justify: "space-between",
                            gap: [
                                20
                            ],
                            flexDir: [
                                "column",
                                null,
                                null,
                                "row"
                            ],
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    flex: 6,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("form", {
                                            onSubmit: formik.handleSubmit,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                flexDir: "column",
                                                gap: [
                                                    5,
                                                    null,
                                                    null,
                                                    10
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: [
                                                            "column",
                                                            null,
                                                            null,
                                                            "row"
                                                        ],
                                                        justify: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "name",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Nama*" : "Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                w: [
                                                                    "100%",
                                                                    null,
                                                                    null,
                                                                    600
                                                                ],
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "name",
                                                                        name: "name",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Nama Anda" : "Your Name",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.name
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: [
                                                            "column",
                                                            null,
                                                            null,
                                                            "row"
                                                        ],
                                                        justify: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "email",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: "Email*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                w: [
                                                                    "100%",
                                                                    null,
                                                                    null,
                                                                    600
                                                                ],
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "email",
                                                                        name: "email",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Email" : "Your email",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.email
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.email
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: [
                                                            "column",
                                                            null,
                                                            null,
                                                            "row"
                                                        ],
                                                        justify: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "phone",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Telepon*" : "Phone*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                w: [
                                                                    "100%",
                                                                    null,
                                                                    null,
                                                                    600
                                                                ],
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "phone",
                                                                        name: "phone",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: "12345678",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.phone
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: [
                                                            "column",
                                                            null,
                                                            null,
                                                            "row"
                                                        ],
                                                        justify: "space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "message",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Pesan*" : "Message*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                flexDir: "column",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Textarea */ .gxH, {
                                                                        fontSize: "sm",
                                                                        w: [
                                                                            "full",
                                                                            null,
                                                                            null,
                                                                            600
                                                                        ],
                                                                        id: "message",
                                                                        name: "message",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Tambahkan pesan pribadi disini..." : "Add your personal message here...",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.message
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.message
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: [
                                                "flex-start",
                                                null,
                                                null,
                                                "flex-end"
                                            ],
                                            mt: 10,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                sitekey: (_NEXT_PUBLIC_CAPTCHA_SITE_KEY = "6LffTCkgAAAAAOh8Ko1Zx6016qXUseJu2gwQECFl") !== null && _NEXT_PUBLIC_CAPTCHA_SITE_KEY !== void 0 ? _NEXT_PUBLIC_CAPTCHA_SITE_KEY : "",
                                                onChange: function(value) {
                                                    return setCapKey(value);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: [
                                                "flex-start",
                                                null,
                                                null,
                                                "flex-end"
                                            ],
                                            mt: 10,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                variant: "dark",
                                                bg: color,
                                                type: "submit",
                                                _hover: {},
                                                cursor: formik.isSubmitting || !formik.isValid || formik.status == "success" ? "not-allowed" : "pointer",
                                                onClick: handleClick,
                                                disabled: formik.isSubmitting || !formik.isValid || !formik.values.name || formik.status == "success" || !isCapValid,
                                                children: formik.isSubmitting ? locale == "id" ? "Mengirim Pesan.." : "Sending Messages.." : formik.status == "success" ? locale == "id" ? "Pesan berhasil terkirim!" : "Thank you for getting in touch!" : locale == "id" ? "Kirim Pesan" : "Messages"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                    flex: 3,
                                    ml: 30,
                                    fontSize: "sm",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                            mb: 4,
                                            children: location
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                            children: [
                                                "tel:",
                                                phone1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                            children: [
                                                "mail:",
                                                email1
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 4853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

}]);